import AuthenticationActions, {
  AuthenticationSelectors,
} from "Redux/AuthenticationRedux";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import React, { Component } from "react";

import Button from "Components/Button";
import { Container } from "./styles";
import { Fonts } from "Themes";
import LoadingIcon from "Components/LoadingIcon";
import SideProject from "Components/SideProject";
import UpdateProjectForm from "Forms/UpdateProjectForm";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import styled from "styled-components";
import styles from "./styles.module.scss";

const StartProjectButton = styled(Button)`
  width: 200px;
`;

class PostUpdateContainer extends Component {
  state = {
    fetching: true,
    showUpdateModal: false,
    projectToUpdate: {},
  };

  async componentDidMount() {
    const {
      getUserDetails,
      getUserProjects,
      userDetails: { id },
    } = this.props;
    await getUserDetails();

    const resolve = {
      onSuccess: () => this.setState({ fetching: false }),
      onFailure: (e) => console.log(e),
    };

    await getUserProjects(id, resolve);
  }

  renderProjects = () => {
    const { userProjects, history } = this.props;
    const { fetching } = this.state;

    if (fetching) return <LoadingIcon />;

    if (userProjects.length === 0) {
      return (
        <StartProjectButton
          onClick={() => history.push(navRoutes.createProject)}
          style={{ width: "30%" }}
        >
          Click here to create a project to start your updates!
        </StartProjectButton>
      );
    }

    return userProjects.map((project, key) => {
      return (
        <SideProject
          showTitle
          showRating
          key={key}
          icon={project.projectIcon}
          title={project.projectName}
          onClick={() =>
            this.setState({ showUpdateModal: true, projectToUpdate: project })
          }
          project={project}
        />
      );
    });
  };

  handleUpdateProject = async (values) => {
    const { createProjectUpdate } = this.props;
    const { projectToUpdate } = this.state;

    this.setState({ submitting: true });

    const resolve = {
      onSuccess: () =>
        this.setState({
          submitSuccess: true,
          submitError: false,
        }),
      onFailure: (e) =>
        this.setState({
          submitError: true,
          submitSuccess: false,
        }),
    };

    const data = {
      id: projectToUpdate.id,
      update: values.update,
      updateDescription: values.updateDescription,
    };

    await createProjectUpdate(data, resolve);

    this.setState({
      submitting: false,
    });
  };

  renderUpdateModal = () => {
    const {
      showUpdateModal,
      projectToUpdate,
      submitting,
      submitError,
      submitSuccess,
    } = this.state;
    return (
      <UpdateProjectForm
        project={projectToUpdate}
        handleSubmit={this.handleUpdateProject}
        openModal={showUpdateModal}
        fetching={submitting}
        error={submitError}
        success={submitSuccess}
        closeModal={() =>
          this.setState({
            showUpdateModal: false,
            submitError: false,
            submitSuccess: false,
            submitting: false,
          })
        }
      />
    );
  };

  render() {
    const { fetching } = this.state;

    return (
      <Container>
        <h1 style={Fonts.headerFont}>Choose a project to update</h1>
        {fetching ? (
          <LoadingIcon />
        ) : (
          <div className={styles.projectsContainer}>
            {this.renderProjects()}
          </div>
        )}
        {this.renderUpdateModal()}
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userDetails: AuthenticationSelectors.getUserDetails(state),
    userProjects: ProjectSelectors.getUserProjects(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetails: (data) =>
      dispatch(AuthenticationActions.getUserDetailsRequest(data)),
    getUserProjects: (data, resolve) =>
      dispatch(ProjectActions.getUserProjectsRequest(data, resolve)),
    createProjectUpdate: (data, resolve) =>
      dispatch(ProjectActions.createProjectUpdateRequest(data, resolve)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PostUpdateContainer);
